// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/styles/fonts.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Graphik", sans-serif !important;
}

:root {
  --primary-background-color: rgba(247, 247, 247, 1);
  --secondary-background-color: rgba(255, 255, 255, 1);
  --primary-border-color: rgba(163, 163, 163, 1);
}

body{
  background-color: var(--primary-background-color);
}

.custom_btn:hover{
  background: #3f41d1 !important;
  color:#fff;
}

  `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,kDAAkD;EAClD,oDAAoD;EACpD,8CAA8C;AAChD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,8BAA8B;EAC9B,UAAU;AACZ","sourcesContent":["@import url('./assets/styles/fonts.css');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Graphik\", sans-serif !important;\n}\n\n:root {\n  --primary-background-color: rgba(247, 247, 247, 1);\n  --secondary-background-color: rgba(255, 255, 255, 1);\n  --primary-border-color: rgba(163, 163, 163, 1);\n}\n\nbody{\n  background-color: var(--primary-background-color);\n}\n\n.custom_btn:hover{\n  background: #3f41d1 !important;\n  color:#fff;\n}\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
